import React from "react";
import { Loader } from "semantic-ui-react";
export const Host = {
  id: "Host",
  title: "Host",
  style: { width: "300px" },
  render: (host) => {
    return host.Host;
  },
};

export const Envide = {
  id: "Envide",
  title: "Envide",
  style: { width: "120px" },
  render: (host) => {
    return host.Envide;
  },
};

export const Active = {
  id: "Blue/Green",
  title: "Blue/Green",
  style: { width: "120px" },
  render: (host, activeStatus) => {
    if (host.MES === "MES16") {
      if (activeStatus && activeStatus[host.Host]) {
        const active = activeStatus[host.Host];
        return <span className={`${active}-status`}> {active}</span>;
      } else {
        return <Loader active inline size="tiny" />;
      }
    } else {
      return <span className={`${host.Active}-status`}> {host.Active}</span>;
    }
  },
};

export const Scope = {
  id: "Scope",
  title: "Scope",
  style: { width: "120px" },
  render: (host) => {
    return host.Scope;
  },
};

export const Stage = {
  id: "Stage",
  title: "Stage",
  style: { width: "120px" },
  render: (host) => {
    return host.Stage;
  },
};

export const Name = {
  id: "Name",
  title: "Alias",
  style: {},
  render: (host) => {
    return host.Name;
  },
};
